import syncQuery from 'vue-sync-query-mixin'
import cleanEmptyValues from '@/mixins/cleanEmptyValues'
import { getPageSize } from '@/components/table/helpers/pageSize'
import { POSTFIX_PAGESIZE, PREFIX_DEFAULT } from '@/components/table/helpers/tablePrefixes'

export default {
  mixins: [syncQuery],
  methods: {
    /**
     * Find Field in sortQueryArray and then returns field sort direction value. Eg: `asc` / `desc`.
     *
     * @param {String} field Table field name.
     * @returns {String}
     * */
    sortBy(fieldName) {
      if (!this.sortQueryArray) return ''

      const field = this.sortQueryArray.find((field) => field.name === fieldName)

      return field ? field.direction : ''
    },

    /**
     * Sync Vue component value <=== url query value.
     *
     * @param {String} localField Vue component property.
     * @param {String} queryField Url query parameter.
     * @returns {Void} Sync Vue component value <=== url query value.
     * */
    syncComponentField(localField, queryField) {
      this[localField] = this[queryField]
    },

    /**
     * Sync Vue component value ===> url query value.
     *
     * @param {String} localField Vue component property.
     * @param {String} queryField Url query parameter.
     * @returns {Void} Sync Vue component value ===> url query value.
     * */
    syncQueryField(localField, queryField) {
      this[queryField] = this[localField]
    },

    /**
     * Update multiple query params.
     *
     * @param {Object} params new url params.
     * @returns {Void} Make router.push() with `params`
     */
    updateQueryParams(params) {
      const query = cleanEmptyValues(params.query)

      this.$router.push({ query })
    },

    /**
     * Returns prepared params for send it to backend.
     *
     * @param {Object} pagination params as default.
     * @returns {Object} Returns prepared params for send it to backend.
     */
    colletQueryParams(params = this.$query) {
      const TableLSId = PREFIX_DEFAULT + this.storageId + POSTFIX_PAGESIZE

      const defaultParams = {
        page: this.$query.page || 1,
        pageSize: getPageSize.call(this, TableLSId),
      }

      /**
       * If query parameter is one, then create Array with one param,
       * else just set params.sort = this.$query.sort.
       */
      if (this.$query.sort) {
        params.sort = this.$query.sort

        if (typeof this.$query.sort === 'string') {
          params.sort = new Array(this.$query.sort)
        }
      }

      const result = Object.assign({}, defaultParams, params)

      return result
    },

    /**
     * Returns array of query fields. Eg: => [ { name: id, direction: asc } ]
     * If query parameter is one, then create Array with one param,
     * else map sort Array and extract each param data.
     *
     * @returns {Array}
     * */
    parseSortingString(sort) {
      const extractParamData = (param) => {
        const [name, direction] = param.split('.')

        return { name, direction }
      }

      if (!sort) return [{ name: '', direction: '' }]

      if (typeof sort === 'string') return new Array(extractParamData(sort))

      return sort.map((param) => extractParamData(param))
    },

    hasQuery(parameter) {
      return Object.keys(this.$query).find((key) => key.indexOf(parameter) !== -1)
    },
  },
  computed: {
    /**
     * @returns Url query object params.
     * */
    $query() {
      return this.$route.query
    },

    /**
     * Returns array of query fields. Eg: => [ { name: id, direction: asc } ]
     *
     * @returns {Array}
     * */
    sortQueryArray() {
      if (!this.$query.sort) return

      return this.parseSortingString(this.$query.sort)
    },
  },
}
